import { get, ref } from "firebase/database";
import { db } from "../lib/firebase";
import { LaunchError } from "../utils/errors";
import { CONTENT_GENERATOR_AD_TEMPLATES_NODE } from "../utils/adGenerationTemplates";

/**
 * Shared content-generator formats live at contentGeneratorAdTemplates.
 * Every advertiser reads the same node. The client can read it and cannot
 * write it. Usage is incremented by the generate worker, not here.
 */
export const startGetContentGeneratorAdTemplates = () => async (dispatch) => {
  try {
    const snapshot = await get(ref(db, CONTENT_GENERATOR_AD_TEMPLATES_NODE));
    return {
      ok: true,
      value: snapshot.exists() ? snapshot.val() : null,
    };
  } catch (error) {
    dispatch(
      LaunchError(error, false, [], {
        functionName: "startGetContentGeneratorAdTemplates",
        context: {},
        tags: { action: "getContentGeneratorAdTemplates" },
        level: "warning",
      })
    );
    return { ok: false, value: null };
  }
};
